// Packages
import React from "react";
// import axios from "axios";
import { Link } from "react-router-dom";

// Styles
import "./schoolAdmin.css";

// material Ui
import MaterialTable from "material-table";
import SchoolAdminDashboard from "./schoolAdminDashboard";

// Services
import userService from "../../services/user.service";

// Assets
import menuthree from "../../assets/images/menuthree.png";
import backArrow from "../../assets/images/backArrow.png";
// All Urls

const columns = [
  { title: "id", field: "id", hidden: true },
  { title: "COACH NAME", field: "firstName" },

  {
    title: "SIGN-UP DATE",
    field: "lastName",
    type: "date",
    dateSetting: { locale: "en-US" },
  },
  { title: "ATHLETES", field: "email" },
  { title: "SPECIALITY", field: "createdAt" },
  { title: "PHONE NO", field: "specialty" },
  { title: "STATUS", field: "remaining" },
  {
    render: (rowData) => (
      <div class="dropdown">
        <span className="cp three-dot pr-2">
          <img className="cp" src={menuthree} alt="menu" />{" "}
        </span>
        <div class="dropdown-content">
          <Link className="p-0" to={`/editteams/${rowData.id}`}></Link>
        </div>
      </div>
    ),
  },
];

class Storage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allSchoolList: [],
    };
  }
  componentDidMount() {
    this.getSchoolData();
  }

  getSchoolData() {
    userService
      .getAllCoaches()
      .then((response) => {
        console.log(response);
        var allSchoolList = response.data.data.coaches;
        console.log(allSchoolList);
        this.setState({ allSchoolList });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  render() {
    return (
      <div className="content">
        <div className="content-layout p-0">
          <SchoolAdminDashboard />
          {/* <div className="clear10"></div> */}
          <div className="container">
            <div className="row">
              <div className="col-6 col-sm-6 col-md-6 col-lg-6 top-strip pt-28">
                {/* <h4 className="fs-24 black bold ml-14">TEAMS</h4> */}
                <p>
                  <Link to="/schoolteams">
                    <span className="fs-22 black semi-bold">TEAMS</span>
                  </Link>{" "}
                  <img src={backArrow} alt="" />{" "}
                  <span>TEAM NAME HERE:Coaches</span>
                </p>
              </div>
              <div className="col-6 col-sm-6 col-md-6 col-lg-6 top-strip pt-28">
                <div className="row">
                  <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-right"></div>
                  <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-right"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="clear20"></div>

          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <MaterialTable
              title=""
              data={this.state.allSchoolList}
              columns={columns}
              options={{
                selection: true,
                headerStyle: { fontFamily: "Rajdhani-Bold", fontSize: 14 },
                rowStyle: { fontSize: 17, fontFamily: "Rajdhani-SemiBold" },
                pageSize: 10,
              }}
            ></MaterialTable>
          </div>
        </div>
      </div>
    );
  }
}
export default Storage;
